import { render } from "./VUEAppContentRiassuntoAccelerometri.vue?vue&type=template&id=0379ce9c"
import script from "./VUEAppContentRiassuntoAccelerometri.vue?vue&type=script&lang=js"
export * from "./VUEAppContentRiassuntoAccelerometri.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__